'use strict';

import Image from "./Image";

function renderPassports(itemKey, passports) {
    return passports.map((passport, index) => {
        return <a key={`${itemKey}_passport_${index}`} href={passport.file}
                  className="passanger-item__passport"
                  data-type={passport.isImage ? 'image' : 'iframe'}
                  data-fancybox={`${itemKey}_passport`}>
            <Image src={passport.thumbnail} />
        </a>
    })
}

export default function PassengerItem({itemKey, passenger, buttons, error}) {
    const selectedPassports = (passenger.passportsExtended || []).filter(p => p.isSelected);

    return <div className="passanger-item">
        <div className="passanger-item__desc">
            <div className="passanger-item__name">
                {passenger.lastName} {passenger.firstName} {passenger.thirdName}
            </div>
            <p>{passenger.type}</p>
            <div className="passanger-item__btns">
                {buttons.map((button, index) => <a
                    key={`${itemKey}_button_${index}`}
                    className={button.className}
                    onClick={button.onClick}
                >{button.text}</a>)}
            </div>
            {error && <div className="error-message">{error}</div>}
        </div>
        <div className="passanger-item__img">
            {renderPassports(itemKey, selectedPassports)}
        </div>
    </div>
}
